/* eslint-disable no-use-before-define */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line max-len
export default function rainbowAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame) {
  let prevX;
  let prevY;

  canvasToCursor.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

  canvasToCursor.addEventListener('mousedown', () => {
    if (toolState.currentToolId === 'rainbow') {
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      isMouseDown = true;
      for (let i = 0; i < canvasMain.width; i++) {
        for (let j = 0; j < canvasMain.height; j++) {
          ctxMain.beginPath();
          ctxMain.fillStyle = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`;
          ctxMain.fillRect(i, j, 1, 1);
        }
      }
    }
  });

  canvasToCursor.addEventListener('mouseup', () => {
    if (toolState.currentToolId === 'rainbow') {
      isMouseDown = false;
      ctxMain.beginPath();
      copyCanvas(canvasMain, canvasCur(returnCurrentFrame()));
    }
  });

  canvasToCursor.addEventListener('mouseout', () => {
    if (toolState.currentToolId === 'rainbow') {
      ctxToCursor.beginPath();
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      ctxToCursor.fill();
      showCursorCoords();
    }
  });

  canvasToCursor.addEventListener('mousemove', (e) => {
    if (toolState.currentToolId === 'rainbow') {
      showCursorCoords(e.offsetX, e.offsetY);
      if (isMouseDown === false) {
        ctxToCursor.beginPath();
        ctxToCursor.clearRect(prevX, prevY, 1, 1);
        ctxToCursor.fill();
        prevX = e.offsetX;
        prevY = e.offsetY;
        ctxToCursor.fillStyle = 'rgba(255,255,255, 0.5)';
        ctxToCursor.fillRect(e.offsetX, e.offsetY, 1, 1);
      }
    }
  });
}
